import { render, staticRenderFns } from "./ModalInativarBeneficiario.vue?vue&type=template&id=46232159&scoped=true"
import script from "./ModalInativarBeneficiario.vue?vue&type=script&lang=js"
export * from "./ModalInativarBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./ModalInativarBeneficiario.vue?vue&type=style&index=0&id=46232159&prod&lang=css"
import style1 from "./ModalInativarBeneficiario.vue?vue&type=style&index=1&id=46232159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46232159",
  null
  
)

export default component.exports